import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const StyledButton = styled(Button)(({ theme, height, width }) => ({
  borderRadius: "1.5rem",
  width: width,
  height: height,
  fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: 600,
  letterSpacing: "0.025em",
  textTransform: "none",
  boxShadow: "0 4px 14px 0 rgba(99, 102, 241, 0.25)",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  overflow: "hidden",
  '&:before': {
    content: '""',
    position: "absolute",
    top: 0,
    left: "-100%",
    width: "100%",
    height: "100%",
    background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
    transition: "left 0.5s",
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: "translateY(-2px)",
    boxShadow: "0 8px 25px 0 rgba(99, 102, 241, 0.4)",
    '&:before': {
      left: "100%",
    },
  },
  '&:active': {
    transform: "translateY(0px)",
    boxShadow: "0 4px 14px 0 rgba(99, 102, 241, 0.25)",
  },
}));
